import React from 'react';
import PropTypes from 'prop-types';

// components
import {Modal, Uploader} from '@drivesally/sally-ui';

// local components
import Container from './components/Content';

const UploadChargesModal = ({loading, visible, onClose, onUpload}) => (
  <Modal
    title="Upload tesla charges"
    icon="upload"
    visible={visible}
    onClose={onClose}
  >
    {(Content) => (
      <Content padding="none">
        <Container>
          <Uploader loading={loading} onChange={onUpload} accept=".csv" small />
        </Container>
      </Content>
    )}
  </Modal>
);

UploadChargesModal.propTypes = {
  loading: PropTypes.bool,
  visible: PropTypes.bool,
  onClose: PropTypes.func,
  onUpload: PropTypes.func,
};

export default UploadChargesModal;
